import { render } from "./PingGuView.vue?vue&type=template&id=47f37eb6&scoped=true&ts=true"
import script from "./PingGuView.vue?vue&type=script&lang=ts"
export * from "./PingGuView.vue?vue&type=script&lang=ts"

import "./PingGuView.vue?vue&type=style&index=0&id=47f37eb6&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f37eb6"]])

export default __exports__